import {Badge, FC, useMemo} from 'external/react'
import { formatUnix } from 'external/moment'
import PaymentMethod from '../PaymentMethod'
import Icon from 'external/fortawesome'

type PaymentHistoryItemProps = {
  invoice: any
}

const PaymentHistoryItem: FC<PaymentHistoryItemProps> = props => {
  const {invoice} = props
  const {hosted_invoice_url} = invoice
  const period = useMemo(() => invoice.lines.data[0].period, [invoice.lines])
  const cardDetails = invoice.charge_object?.payment_method_details?.card
  const card = cardDetails?.brand
  const last4 = cardDetails?.last4

  return (
    <tr>
      <td><a href={hosted_invoice_url} target='_blank'>{formatUnix(period.start)}</a></td>
      <td>suscripción</td>
      <td>{`${formatUnix(period.start)} - ${formatUnix(period.end)}`}</td>
      <td align='center' ><PaymentMethod className='m-auto' card={card} last4={last4} showLabel={false} /></td>
      {invoice.status == 'paid' && ( <td> <Badge pill bg='primary'>Completado</Badge></td>)}
      <td>${(invoice.total / 100).toFixed(2)}</td>
      {invoice.status == 'open' && (
        <td>
          <Badge pill bg='danger'>Declinada</Badge><a href={invoice.hosted_invoice_url}>
          <Icon name='faHandHoldingDollar' className='ml-3' title='Haz click para pagar!' style={{ fontSize: '18px', color: '#2d1a1a' }} /></a>
          <Icon name='faExclamationTriangle' className='ml-3' title={invoice.charge_object?.outcome?.reason}></Icon>
        </td>
      )}
    </tr>
  )
}
export {PaymentHistoryItem as default}